import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'toutesLettresMajusculePipe'
})
export class ToutesLettresMajusculePipeMock implements PipeTransform {

	constructor() {
	}

	transform(value: any): any {
		return value;
	}

}
